module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Kathy_CR-p-500-714ac8deda0d1cb455fee890d549aa82.jpg";